import { Loader } from "@circle-react-uikit/Loader";

export const LoaderRow = ({ className = "" }) => (
  <div className="flex w-full items-center justify-center">
    <Loader className={className} />
  </div>
);
